import {
    Box,
    Skeleton,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Typography,
} from '@mui/material';
import Icon from '@apigrowfinance/pbolt-icon';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

export type AccountHistoryItemProps = {
    disableGutter?: boolean;
};

const AccountHistoryItemSkeleton = ({
    disableGutter = false,
}: AccountHistoryItemProps) => {
    const { theme } = useTheme();

    return (
        <Box data-testid="timelineitem-skeleton">
            <ListItem
                disableGutters={disableGutter}
                sx={{
                    pb: 0.5,
                    bgcolor: 'background.paper',
                    mb: '2px',
                }}
                secondaryAction={
                    <ListItemText
                        primaryTypographyProps={{
                            style: {
                                textAlign:
                                    theme.direction === 'rtl'
                                        ? 'left'
                                        : 'right',
                            },
                        }}
                        primary={
                            <Box data-testid="secondary-title">
                                <Skeleton width={60} height={30} />
                            </Box>
                        }
                    />
                }>
                <ListItemAvatar>
                    <Icon isLoading data-testid="avatar-icon">
                        <div />
                    </Icon>
                </ListItemAvatar>

                <ListItemText
                    primary={
                        <Typography
                            variant="h6"
                            data-testid="history-item-session">
                            <Skeleton width={220} />
                        </Typography>
                    }
                    secondary={
                        <>
                            <Box
                                component="span"
                                data-testid="history-item-user">
                                <Skeleton width={150} height={11} />
                            </Box>
                            <Box
                                component="span"
                                data-testid="history-item-notes">
                                <Skeleton
                                    sx={{ pb: 0 }}
                                    width={150}
                                    height={11}
                                />
                            </Box>
                        </>
                    }
                />
            </ListItem>

            <ListItem
                disableGutters
                sx={{
                    b: theme.spacing(1),
                    bgcolor: 'background.paper',
                    mb: 2,
                    py: 0.57,
                }}>
                <ListItemText
                    sx={{ p: 0, ml: 9 }}
                    secondary={<Skeleton width={200} height={20} />}
                />
            </ListItem>
        </Box>
    );
};

export default AccountHistoryItemSkeleton;
